export {};
//# sourceMappingURL=expose-options.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/decorator-options/expose-options.interface.js
// module id = 791
// module chunks = 3